var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import classNames from "classnames";
import Icon from "../Icon/Icon";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";
import * as authUtils from "utils/auth";

import styles from "./AuthDrawer.css";

var RegisterOne = function (_Component) {
  _inherits(RegisterOne, _Component);

  function RegisterOne(props) {
    _classCallCheck(this, RegisterOne);

    var _this = _possibleConstructorReturn(this, (RegisterOne.__proto__ || Object.getPrototypeOf(RegisterOne)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(RegisterOne, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      authUtils.setNonce();
      this.setState({
        fbAuthUrl: authUtils.getFacebookUrl(),
        linkedInAuthUrl: authUtils.getLinkedInUrl()
      });
    }
  }, {
    key: "changeStep",
    value: function changeStep(step, event) {
      if (event) {
        event.preventDefault();
      }

      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.container },
        React.createElement(
          "div",
          { className: styles.muted },
          "Join Axios to save stories for later, get personalized news, and more!"
        ),
        React.createElement(
          "div",
          { className: styles.linkedInButton },
          React.createElement(
            "a",
            { href: this.state.linkedInAuthUrl, className: classNames(styles.blueButton1, styles.block, styles.centered) },
            React.createElement(Icon, { name: "linkedin-inverse", path: "img", className: styles.icon }),
            "Register with LinkedIn"
          )
        ),
        React.createElement(
          "div",
          { className: styles.facebookButton },
          React.createElement(
            "a",
            { href: this.state.fbAuthUrl, className: classNames(styles.blueButton2, styles.block, styles.centered) },
            React.createElement(Icon, { name: "facebook-inverse", path: "img", className: styles.icon }),
            "Register with Facebook"
          )
        ),
        React.createElement(
          "div",
          { className: styles.orWord },
          "OR"
        ),
        React.createElement(
          "div",
          { className: classNames(styles.marginTop10, styles.registerWithEmailButton) },
          React.createElement(
            "a",
            { onClick: this.changeStep.bind(this, authDrawerConstants.REGISTER2), href: "#", className: classNames(styles.grayButton1, styles.block, styles.centered) },
            React.createElement(Icon, { name: "envelope", path: "img", className: styles.icon }),
            "Register with Email"
          )
        ),
        React.createElement(
          "div",
          { className: classNames(styles.marginTop40, styles.textCenter) },
          "Already an Axios member? ",
          React.createElement(
            "a",
            { onClick: this.changeStep.bind(this, authDrawerConstants.SIGNIN), href: "#", className: classNames(styles.blackLink, styles.bold) },
            "Sign in now."
          )
        )
      );
    }
  }]);

  return RegisterOne;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterOne);


// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/RegisterOne.js